export const BUY_X_GET_Y = 'BUY X GET Y';
export const FREE_ITEM = 'FREE ITEM';
export const DISCOUNT_PER_ITEM = 'DISCOUNT PER ITEM';
export const MOKA_ORDER_PRICE_CUTS = 'Moka Order Price Cuts';
export const ADVANCE_PROMO = 'DISCOUNT TO CART';
